<div class="avatar" [style.backgroundImage]="bgImageStyle"></div>
